/**
 * @private
 * @param {*} color int;#rrggbb;rgba();rgb();pdf color array:[T], [RGB,r,g,b] [cmyk,r,g,b];
 * @param {*} outType  'HTML' --> rgba()
'RGB' --> []
'#' --> #ff0000
'int' --> 0xaabbbcc
 * @param {*} opacity 
 */
export function colorConvertor(color, outType = 'HTML', opacity = 1) {
  var value = '';
  var R, G, B;
  let components;
  if (typeof color == 'number') {
    color = ['int', color];
  }
  switch (color[0]) {
    case 'int':
      R = (color[1] & 0x00ff0000) >> 16;
      G = (color[1] & 0x0000ff00) >> 8;
      B = color[1] & 0x000000ff;
      break;
    case 'T':
      R = 0;
      G = 0;
      B = 0;
      opacity = 0;
      break;
    case 'G':
      R = G = B = color[1] * 255;
      break;
    case 'RGB':
      R = color[1] * 255;
      G = color[2] * 255;
      B = color[3] * 255;
      break;
    case 'CMYK':
      R = (1 - color[4]) * (1 - color[1]) * 255;
      G = (1 - color[4]) * (1 - color[2]) * 255;
      B = (1 - color[4]) * (1 - color[3]) * 255;
      break;
    case 'r':
      components = color.match(/rgba?\((\d*),\s*(\d*),\s*(\d*),?\s*([\.0-9]*)?\)/);
      R = +components[1];
      G = +components[2];
      B = +components[3];
      break;
    case '#':
      let p = color.length == 4 ? /#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/ : /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/;
      components = color.match(p);
      R = parseInt(components[1], 16);
      G = parseInt(components[2], 16);
      B = parseInt(components[3], 16);
      break;
    default:
      throw new Error('Unsupported color format');
  }
  switch (outType) {
    case 'HTML':
      if (R === G && G === B && B === -1) {
        value = 'transparent';
      } else {
        value = 'rgba(' + parseInt(R) + ',' + parseInt(G) + ',' + parseInt(B) + ',' + opacity + ')';
      }
      break;
    case 'RGB':
      value = ['RGB', R / 255, G / 255, B / 255];
      break;
    case '#':
      if (R < 16) {
        value += '#0' + R.toString(16);
      } else {
        value += '#' + R.toString(16);
      }
      if (G < 16) {
        value += '0' + G.toString(16);
      } else {
        value += G.toString(16);
      }
      if (B < 16) {
        value += '0' + B.toString(16);
      } else {
        value += B.toString(16);
      }
      break;
    case 'int':
      value = 0;

      opacity *= 255;
      value |= opacity << 24;
      value |= R << 16;
      value |= G << 8;
      value |= B;
      value = value >>> 0;
      break;
  }

  return value;
}
